import axios from 'axios'
import qs from 'qs'

const service = axios.create({
  // baseURL: 'http://test.weicistudy.com:83/',
  baseURL: 'http://api.weicistudy.com',
  timeout: 60000,
  responseType: 'json',
  withCredentials: false, // 是否允许带cookie这些
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
  }
})

// POST传参序列化(添加请求拦截器)
service.interceptors.request.use(
  config => {
    // 在发送请求之前做某件事
    // 添加系统级参数
    if (config.method === 'get') {
      config.params = {
        ...config.params
      }
    } else if (config.method === 'post') {
      config.data = qs.stringify({
        ...config.data
      })
    }
    // console.log(config)
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 返回状态判断(添加响应拦截器)
service.interceptors.response.use(
  res => {
    return res
  },
  error => {
    // 用户登录的时候会拿到一个基础信息,比如用户名,token,过期时间戳
    // 直接丢sessionStorage或者sessionStorage
    // if (!window.sessionStorage.getItem('loginInfo')) {
    //   // 若是接口访问的时候没有发现有鉴权的基础信息,直接返回登录页
    //   Message({
    //     showClose: true,
    //     message: '登录状态信息过期,请重新登录1',
    //     type: 'error'
    //   })
    // } else {
    //   // console.log(error)
    //   // 若是有基础信息的情况下,判断时间戳和当前的时间,若是当前的时间大于服务器过期的时间
    //   // 乖乖的返回去登录页重新登录
    //   let lifeTime = JSON.parse(window.sessionStorage.getItem('loginInfo')).life_time
    //   let nowTime = new Date().getTime() // 当前时间的时间戳
    //
    //   if (nowTime > lifeTime) {
    //     Message({
    //       showClose: true,
    //       message: '登录状态信息过期,请重新登录2',
    //       type: 'error'
    //     })
    //   } else {
    //     // 下面是接口回调的satus ,因为我做了一些错误页面,所以都会指向对应的报错页面
    //     // if (error.response.status === 403) {
    //     //   router.push({
    //     //     path: '/error/403'
    //     //   })
    //     // }
    //     // if (error.response.status === 500) {
    //     //   router.push({
    //     //     path: '/error/500'
    //     //   })
    //     // }
    //     // if (error.response.status === 502) {
    //     //   router.push({
    //     //     path: '/error/502'
    //     //   })
    //     // }
    //     // if (error.response.status === 404) {
    //     //   router.push({
    //     //     path: '/error/404'
    //     //   })
    //     // }
    //
    //     Message({
    //       showClose: true,
    //       message: '发生系统级错误，请稍后重试！',
    //       type: 'error'
    //     })
    //   }
    // }
    // 返回 response 里的错误信息
    let errorInfo = error.data ? error.data.message : error.data
    return Promise.reject(errorInfo)
  }
)

export default service
